import '../css/Promo.css'

export default function PromoSticky() {
  return (
  <div className = "smallBackgroundTopSticky">
    <p className = "adjustTopText">Call (480)-826-7345 or Email bubspups907@gmail.com to schedule your dog today!</p>
  </div>
  );
}